import { SelectBox } from 'devextreme-react'
import React, { useState } from 'react'
import { Button, Card, Col, Row } from 'reactstrap'
import Breadcrumb from '../../components/common/breadcrumb'
import useFormatMessage from '../../utils/useFormatMessage'

const StokIzleme = () => {
    const { t } = useFormatMessage()

    /* eslint-disable no-unused-vars */
    const [brandList, setBrandList] = useState([
        { id: 1, name: "Brand 1" },
        { id: 2, name: "Brand 2" },
        { id: 3, name: "Brand 3" },
        { id: 4, name: "Brand 4" },
        { id: 5, name: "Brand 5" },
    ])
    const [modelList, setModelList] = useState([
        { id: 1, name: "Model 1" },
        { id: 2, name: "Model 2" },
        { id: 3, name: "Model 3" },
        { id: 4, name: "Model 4" },
        { id: 5, name: "Model 5" },
    ])
    const [depotList, setDepotList] = useState([
        { id: 1, name: "Depot 1" },
        { id: 2, name: "Depot 2" },
        { id: 3, name: "Depot 3" },
        { id: 4, name: "Depot 4" },
        { id: 5, name: "Depot 5" },
    ])
    const [regionList, setRegionList] = useState([
        { id: 1, name: "Region 1" },
        { id: 2, name: "Region 2" },
        { id: 3, name: "Region 3" },
        { id: 4, name: "Region 4" },
        { id: 5, name: "Region 5" }

    ])

    /* eslint-disable no-unused-vars */


    return (
        <>
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}>
                <Breadcrumb current={t("Stok İzleme")} />
                <i style={{ cursor: "pointer", fontSize: "18px" }} className="fa fa-refresh mr-2" aria-hidden="true"></i>
            </div>

            <Card className='p-4'>
                <Row>
                    <Col lg="6">
                        <div className=" mb-2 row">
                            <div className=" col-md-4" style={{ color: "black", fontWeight: "500" }}>{t("Marka")}</div>
                            <div className=" col-md-8">
                                <SelectBox id="marka" valueExpr={"id"} displayExpr={"name"} dataSource={brandList} />
                            </div>
                        </div>
                    </Col>
                    <Col lg="6">
                        <div className=" mb-2 row">
                            <div className=" col-md-4" style={{ color: "black", fontWeight: "500" }}>{t("Depo")}</div>
                            <div className=" col-md-8">
                                <SelectBox id="depo" valueExpr={"id"} displayExpr={"name"} dataSource={depotList} />
                            </div>
                        </div>

                    </Col>
                </Row>
                <Row>
                    <Col lg="6">

                        <div className=" mb-2 row">
                            <div className=" col-md-4" style={{ color: "black", fontWeight: "500" }}>{t("Model")}</div>
                            <div className=" col-md-8">
                                <SelectBox id="model" valueExpr={"id"} displayExpr={"name"} dataSource={modelList} />
                            </div>
                        </div>

                    </Col>
                    <Col lg="6">

                        <div className=" mb-2 row">
                            <div className=" col-md-4" style={{ color: "black", fontWeight: "500" }}>{t("Bölge")}</div>
                            <div className=" col-md-8">
                                <SelectBox id="bolge" valueExpr={"id"} displayExpr={"name"} dataSource={regionList} />
                            </div>
                        </div>

                    </Col>
                </Row>
                <Row style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}>
                    <Col lg="2">
                        <Button type="button" className="btn btn-block btn-success p-2" id="btnok">
                            <i className="fa fa-list" aria-hidden="true"></i> &nbsp;{t("Listele")}
                        </Button>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default StokIzleme